export default __webpack_public_path__ + "static/media/027-saline.e5a19773.svg";